import React from 'react';
import { Tag, Button, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import moment from 'moment';

// Ant Design Table format columns (matching Telecom tab style)
// API response fields use PascalCase
export const getCallForwardingColumns = (
  onCancel: (record: any) => void,
  cancelLoading: boolean,
  hasWritePermission: boolean = true
) => [
  {
    title: 'Source Office Number',
    dataIndex: 'SourceOfficeNumber',
    key: 'SourceOfficeNumber',
    width: 170,
  },
  {
    title: 'Source Office Name',
    dataIndex: 'SourceOffice',
    key: 'SourceOffice',
    width: 180,
  },
  {
    title: 'Destination Office Number',
    dataIndex: 'DestinationOfficeNumber',
    key: 'DestinationOfficeNumber',
    width: 170,
  },
  {
    title: 'Destination Office Name',
    dataIndex: 'DestinationOffice',
    key: 'DestinationOffice',
    width: 180,
  },
  {
    title: 'Start Date',
    dataIndex: 'StartDate',
    key: 'StartDate',
    width: 120,
    render: (value: string) => (value ? moment(value).format('YYYY-MM-DD') : ''),
  },
  {
    title: 'End Date',
    dataIndex: 'EndDate',
    key: 'EndDate',
    width: 120,
    render: (value: string) => (value ? moment(value).format('YYYY-MM-DD') : ''),
  },
  {
    title: 'Status',
    dataIndex: 'Status',
    key: 'Status',
    width: 100,
    render: (value: string, record: any) => {
      const today = moment().startOf('day');
      const startDate = record?.StartDate ? moment(record.StartDate).startOf('day') : null;
      const endDate = record?.EndDate ? moment(record.EndDate).endOf('day') : null;
      const shouldDisplayAsActive =
        value === 'Scheduled' && !!startDate && !!endDate && today.isBetween(startDate, endDate, undefined, '[]');
      const displayStatus = shouldDisplayAsActive ? 'Active' : value;

      const colorMap: Record<string, string> = {
        Active: 'green',
        Scheduled: 'blue',
        Expired: 'default',
        Cancelled: 'red',
      };
      return displayStatus ? <Tag color={colorMap[displayStatus] || 'default'}>{displayStatus}</Tag> : '';
    },
  },
  {
    title: 'Reason',
    dataIndex: 'Reason',
    key: 'Reason',
    width: 150,
  },
  {
    title: 'Requested By',
    dataIndex: 'RequestedBy',
    key: 'RequestedBy',
    width: 150,
  },
  {
    title: 'Created Date',
    dataIndex: 'CreatedDate',
    key: 'CreatedDate',
    width: 120,
    render: (value: string) => (value ? moment(value).format('YYYY-MM-DD') : ''),
  },
  {
    title: 'Cancelled By',
    dataIndex: 'CancelledBy',
    key: 'CancelledBy',
    width: 130,
  },
  {
    title: 'Cancelled Date',
    dataIndex: 'CancelledDate',
    key: 'CancelledDate',
    width: 120,
    render: (value: string) => (value ? moment(value).format('YYYY-MM-DD') : ''),
  },
  {
    title: 'Cancellation Reason',
    dataIndex: 'CancellationReason',
    key: 'CancellationReason',
    width: 220,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 80,
    fixed: 'right' as const,
    render: (_: any, record: any) => {
      const isCancelled = record.Status === 'Cancelled';
      const isExpired = record.Status === 'Expired';
      const isActionDisabled = !hasWritePermission || isCancelled || isExpired || cancelLoading;
      const tooltipTitle = isCancelled ? 'Already cancelled' : isExpired ? 'Cannot cancel expired request' : 'Cancel';
      return (
        <Tooltip placement='top' title={tooltipTitle}>
          <Button
            style={{
              backgroundColor: !hasWritePermission || isCancelled || isExpired ? '#ccc' : '#d14d4d',
              border: 'none',
              borderRadius: '5px',
              width: '24px',
              height: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            icon={<CloseOutlined style={{ color: 'white', fontSize: 14 }} />}
            onClick={() => onCancel(record)}
            disabled={isActionDisabled}
            loading={cancelLoading}
          />
        </Tooltip>
      );
    },
  },
  {}, // empty column, workaround to have column width fixed
];

// Keep backward compatibility
export const call_forwarding_columns = getCallForwardingColumns(() => {}, false);
